import Vue from 'vue'

function validateVehicleNo(value){
  return /^[A-Z0-9]{17}$/.test(value);
}

function require(value) {
  return ( value !== '' && value !== false && value !== null && value !== undefined);
}

function date(value) {
  // const date = new RegExp("^(19|20)\\d{2}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])");
  // if (date.exec(value)) return true;
  // return false;
  if(!require(value)) return false;

  const date = Vue.moment(value,'YYYYMMDD',true);
  const format = 'YYYY-MM-DD'

  return  (
    date.isValid()  // date 형식 체크
    && date.format(format) <= Vue.moment().format(format) //오늘날짜보다 클수없다.
    && date.format(format) >= Vue.moment().subtract(30, 'year').format(format) //30년전 X
  );
  
  
}

function numReg(value) {
  if(!require(value)) return false;
  const reg = new RegExp(/^\d{2,3}[가-힣]{1}\d{4}$/);
  return reg.exec(value)
}

function digits(value, n, comparison) {
  if(!require(value)) return false;

  switch (comparison) {
    case '=':
      return value.length == n;
    case '>':
      return value.length >= n;
    case '<':
      return value.length <= n;
    default:
      return false
  }
}

function eng(value) {
  if(!require(value)) return false;
  const reg = new RegExp("^[a-zA-Z]*$");
  return reg.exec(value);
}

function int(value) {
  if(!require(value)) return false;
  const reg = new RegExp("^[0-9]*$");
  return reg.exec(Number(value))[0];
}



export {
  validateVehicleNo,
  date,
  numReg,
  digits,
  eng,
  int,
  require,
}